// extracted by mini-css-extract-plugin
module.exports = {"button":"NextButton_button__3Pdck","disabled":"NextButton_disabled__2-D2A","icon":"NextButton_icon__oHfgn"};